import * as React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';

const IndexPage = () => (
  <Layout>
    <Seo title="FAKTURUJ.TO proste!"/>
  </Layout>
);

export default IndexPage;
